import React from "react";
import PropTypes from "prop-types";
import useController from "./controller";
import BaseIcon from "../BaseIcon";
import "./style.scss";
export default function BaseModal({
  children,
  title,
  description,
  eventTypeModal,
  onPayload,
  className,
  titleStyle,
  contentStyle,
  descriptionStyle,
  containerStyle,
  onClose,
  isNeonTitle,
  preventClose,
}) {
  BaseModal.propTypes = {
    children: PropTypes.node,
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    eventTypeModal: PropTypes.string,
    onPayload: PropTypes.func,
    onClose: PropTypes.func,
    className: PropTypes.string,
    titleStyle: PropTypes.string,
    contentStyle: PropTypes.string,
    containerStyle: PropTypes.string,
    descriptionStyle: PropTypes.string,
    isNeonTitle: PropTypes.bool,
    preventClose: PropTypes.bool,
  };
  const { closeModal, isModalOpen } = useController(
    eventTypeModal,
    onPayload,
    onClose
  );
  const modalCls = ["base-modal base-modal__overflow"];
  const titleCls = ["base-modal__title"];
  const actionsCls = ["base-modal__actions"];
  const descriptionCls = [
    "base-modal__description base-modal__overflow__description",
  ];
  const containerCls = ["modal-container"];
  if (className) modalCls.push(className);
  if (titleStyle) titleCls.push(titleStyle);
  if (contentStyle) actionsCls.push(contentStyle);
  if (descriptionStyle) descriptionCls.push(descriptionStyle);
  if (containerStyle) containerCls.push(containerStyle);
  if (isNeonTitle) titleCls.push("neon-text");
  return (
    isModalOpen && (
      <div className={containerCls.join(" ")}>
        <div
          onClick={preventClose ? () => {} : closeModal}
          id="modal-backdrop"
          className="modal-backdrop"
        />
        <div className={modalCls.join(" ")}>
          <div className="base-modal__wrapper">
            {!preventClose ? (
              <div
                onClick={closeModal}
                id="cross-close"
                className="base-modal__cross-close-container"
              >
                <BaseIcon
                  name="close_cross"
                  className="base-modal__cross-close-container__icon"
                />
              </div>
            ) : null}
            {title ? (
              <div
                data-text={isNeonTitle ? title : ""}
                className={titleCls.join(" ")}
                style={{ marginBottom: description || children ? "25px" : 0 }}
              >
                {title}
              </div>
            ) : null}
            {description && (
              <div
                className={descriptionCls.join(" ")}
                style={{ marginBottom: children ? "25px" : 0 }}
              >
                {description}
              </div>
            )}
            <div className={actionsCls.join(" ")}>{children}</div>
          </div>
        </div>
      </div>
    )
  );
}
